import React from 'react';

import { PATH } from 'src/pages/customerSetting';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { t } from 'src/libs/i18n';
import Layout from 'src/components/layout';
import { SCREENS } from 'src/constants/screens';

const CustomerSettingRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        index: true,
        path: PATH,
        element: loadable(() => import('src/pages/customerSetting')),
        title: t('customer_setting.title'),
        screenId: SCREENS.R1506,
      },
    ],
  },
];

export default CustomerSettingRoute;
